/*
 * hero-cta — retour de chargement sur les boutons de la hero.
 *
 * Ces boutons menent a une autre page. Entre le clic et l'affichage de la page
 * suivante il peut s'ecouler une seconde ou deux pendant lesquelles rien
 * n'indique que le clic a ete pris. On marque le bouton, le CSS s'occupe du
 * reste.
 *
 * Delegation sur le document plutot qu'un ecouteur par bouton : la slideshow
 * peut recreer ses diapositives, un ecouteur pose au chargement serait perdu.
 */

document.addEventListener('click', (event) => {
  const cta = event.target.closest('.slideshow .btn, .slideshow .btn-link');
  if (!cta) return;

  // Rien a signaler sur un bouton desactive ou deja en cours.
  if (cta.getAttribute('aria-disabled') === 'true' || cta.classList.contains('is-loading')) return;

  // Ni sur un lien qui n'entraine pas de navigation : nouvel onglet, ancre,
  // telechargement, ou clic avec une touche de modification.
  const href = cta.getAttribute('href');
  if (!href || href.startsWith('#') || cta.target === '_blank' || cta.hasAttribute('download')) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

  cta.classList.add('is-loading');

  // Filet de securite : si la navigation est annulee ou si la page revient du
  // cache arriere, le bouton ne doit pas rester bloque.
  setTimeout(() => cta.classList.remove('is-loading'), 8000);
});

window.addEventListener('pageshow', () => {
  document
    .querySelectorAll('.slideshow .is-loading')
    .forEach((el) => el.classList.remove('is-loading'));
});
